module.exports = __webpack_public_path__ + "static/media/greatPowersGreatResponsability.a60b0af7.gif";